import React from 'react';
import { Form, Button } from 'react-bootstrap';

/**
 * A component for selecting multiple repair styles for materials
 * 
 * @param {Object} props Component props
 * @param {Array} props.repairStyles List of available repair styles
 * @param {Array} props.selectedRepairStyles Currently selected repair styles
 * @param {Function} props.onChange Callback function when selection changes
 * @returns {JSX.Element} Material repair style selector component
 */
const MaterialRepairStyleSelector = ({ 
  repairStyles = [], 
  selectedRepairStyles = [{ id: null }], 
  onChange
}) => {
  if (!repairStyles || repairStyles.length === 0) {
    return <p>No repair styles available.</p>;
  }

  // Active styles only
  const activeStyles = repairStyles.filter(style => style.status !== false);

  const handleStyleChange = (e) => {
    const styleId = e.target.value;
    if (styleId && styleId !== "null") {
      // Check if style is already selected
      if (!selectedRepairStyles.some(sel => sel.id === styleId)) {
        onChange([...selectedRepairStyles, { id: styleId }]);
      }
    }
  };

  const removeStyle = (styleId) => {
    const updatedStyles = selectedRepairStyles.filter(sel => sel.id !== styleId);
    onChange(updatedStyles.length > 0 ? updatedStyles : [{ id: null }]);
  };

  return (
    <div className="material-repair-style-selector">
      <Form.Group>
        <Form.Label>Select Repair Styles</Form.Label>
        <Form.Control
          as="select"
          onChange={handleStyleChange}
          className="mb-2"
        >
          <option value="null">-- Select Repair Style --</option>
          {activeStyles.map(style => (
            <option key={style.id} value={style.id}>
              {style.name?.az || style.name?.text || "Unnamed Style"}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      {/* Selected Styles */}
      <div className="selected-styles mt-2">
        <h6>Selected Repair Styles:</h6>
        {selectedRepairStyles.filter(sel => sel.id).length === 0 ? (
          <p>No repair styles selected</p>
        ) : (
          <ul className="list-group">
            {selectedRepairStyles
              .filter(sel => sel.id)
              .map(sel => {
                const style = repairStyles.find(s => s.id === sel.id);
                return (
                  <li key={sel.id} className="list-group-item d-flex justify-content-between align-items-center">
                    {style?.name?.az || style?.name?.text || "Unknown Style"}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => removeStyle(sel.id)}
                    >
                      Remove
                    </Button>
                  </li>
                );
              })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MaterialRepairStyleSelector; 